import { DiscountActionEditScreen } from "./discount-action-edit.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import { DiscountCodeRoutes } from "../discount-code";

export const ActiveDiscountActionEditRoutes: RouteDefinition[] = [
	{
		path: Paths.activeDiscountActions.withIdPlaceholder().edit.path,
		element: <DiscountActionEditScreen isArchivePage={false} />,
		requiredPermissions: ["UserInAccountPermission_DiscountAdmin_Modify"],
	},
	...DiscountCodeRoutes,
];

export const ArchivedDiscountActionEditRoutes: RouteDefinition[] = [
	{
		path: Paths.archivedDiscountActions.withIdPlaceholder().edit.path,
		element: <DiscountActionEditScreen isArchivePage={true} />,
		requiredPermissions: ["UserInAccountPermission_DiscountAdmin_Modify"],
	},
];
